import React from "react";

// The EasyFile2290 brand wordmark. One component so the header, footer and
// in-app AppBar can never drift apart.
//
// Two things here are load-bearing:
//
// 1. It is a SINGLE inline <span> with a nested <span>, not two flex children.
//    The three lockups that used to render this inline all sat inside a
//    `flex ... gap-[11px]` link. Once the old "2290" sign plate was removed,
//    "EasyFile" and "2290" became the two flex items and that gap opened up
//    between them — the brand rendered as "EasyFile 2290". Keeping it inline
//    makes the seam impossible to reintroduce from the parent's layout.
//
// 2. Tracking is NEGATIVE (-.03em). The old lockups set tracking-[.02em],
//    which is right for letterspaced UI labels and wrong for a wordmark —
//    a brand name wants its letters tight enough to read as one object.
//
// "EasyFile" inherits colour from the parent link so this works on light and
// dark grounds alike; only "2290" is pinned, to the copper accent.
const SIZES = {
  sm: "text-[21px]",
  md: "text-[25px]",
  lg: "text-[32px]",
};

const Wordmark = ({ size = "md", className = "" }) => (
  <span
    className={[
      "font-disp font-extrabold leading-none tracking-[-.03em] whitespace-nowrap",
      SIZES[size] || SIZES.md,
      className,
    ].join(" ")}
  >
    EasyFile<span className="text-[var(--accent)]">2290</span>
  </span>
);

export default Wordmark;
